export default __webpack_public_path__ + "static/media/x-circle-icon.bed17e5c.svg";